module.exports = __webpack_public_path__ + "img/data-center01.0b02cc11.png";